import MuiBox from "@mui/material/Box";

/**
 * Facade over MUI Box. Customize defaults here.
 */
export default function Box(props) {
  return <MuiBox {...props} />;
}
